import styled from 'styled-components';

import Box from './Box';

const Label = styled('span')`
  background-color: ${props => props.color};
  border-radius: 4px;
  color: #fff;
  font-size: 0.75rem;
  letter-spacing: 1px;
  padding: 0.25rem 0.5rem;
  text-transform: uppercase;
`;

export default Box.withComponent(Label);
